module.exports = __webpack_public_path__ + "img/38.d8988f75.png";